"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDenseSheet = exports.getSheetCell = exports.readWorkbook = void 0;
/* eslint-disable no-console */
const XLSX = __importStar(require("@sheet/edit"));
const common_1 = require("@finley-technologies/common");
const readWorkbook = async (xlsBuffer, options) => {
    try {
        // Note: @sheet/edit 1.x uses a different dense format than newer SheetJS (0.19.0+)
        // - Older format: sheet['0'], sheet['1'] (row index as string keys)
        // - Newer format: sheet['!data'][row][col]
        // Our getSheetCell and isDenseSheet helpers support both formats.
        const workbook = XLSX.read(xlsBuffer, {
            type: 'buffer',
            dense: options.useDenseMode,
            // cellFormula: true, will get us formula along with raw and formatted values
            // we always extract cellFormula, as our config may want it.
            cellFormula: true,
            // we want date values to be read as JS Dates
            // Note this only affect raw values. formatted values are always strings.
            cellDates: true,
        });
        return workbook;
    }
    catch (error) {
        const errorMessage = (0, common_1.getErrorMessage)(error);
        throw new Error(`Failed to read workbook: ${errorMessage}`);
    }
};
exports.readWorkbook = readWorkbook;
/**
 * Helper to get a cell value from a sheet, supporting both sparse and dense formats.
 * @param sheet - The worksheet
 * @param rowIndex - 0-based row index
 * @param colIndex - 0-based column index
 * @returns The cell object or undefined if not found
 */
const getSheetCell = (sheet, rowIndex, colIndex) => {
    // Check if sheet is in dense format
    // Newer SheetJS (0.19.0+): uses sheet['!data'][row][col]
    // Older @sheet/edit (1.x): uses sheet[rowIndex][col] where rowIndex is a string like '0', '1'
    if (sheet['!data'] != null) {
        // Newer format
        return sheet['!data']?.[rowIndex]?.[colIndex];
    }
    // Check for older @sheet/edit dense format (rows stored as sheet['0'], sheet['1'], etc.)
    const rowKey = String(rowIndex);
    const row = sheet[rowKey];
    if (Array.isArray(row)) {
        return row[colIndex];
    }
    // Sparse format - use cell address
    const cellAddressA1 = XLSX.utils.encode_cell({ c: colIndex, r: rowIndex });
    return sheet[cellAddressA1];
};
exports.getSheetCell = getSheetCell;
/**
 * Check if a sheet is in dense format.
 * Supports both newer SheetJS (!data property) and older @sheet/edit (numeric string keys).
 */
const isDenseSheet = (sheet) => {
    // Newer format
    if (sheet['!data'] != null) {
        return true;
    }
    // Older @sheet/edit format - rows are stored as numeric string keys ('0', '1', '2', etc.)
    // Check if any numeric key exists and its value is an array
    // Note: We can't just check sheet['0'] because some sheets may not have data in row 0
    return Object.keys(sheet).some((key) => {
        const num = parseInt(key, 10);
        return !Number.isNaN(num) && Array.isArray(sheet[key]);
    });
};
exports.isDenseSheet = isDenseSheet;
//# sourceMappingURL=readWorkbook.js.map